import React, { useState, useEffect } from "react";
import {BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, LabelList, Label} from "recharts";
import { PieChart, Pie, Sector, Cell } from 'recharts';
import { LineChart, Line} from 'recharts'
import { Modal, Button } from 'react-bootstrap';
import BeatLoader from "react-spinners/BeatLoader";
import 'chart.piecelabel.js';
import 'chartjs-plugin-datalabels';
import './DashBoardStyles.css';


const Charts = (props) => {
    let [filteredData, setFilteredData] = useState(true)
    // const data = Object.values(props.data.count.productionCountAgainstLocation && props.data.count.productionCountAgainstLocation).reduce((file, value) => {
    //     file.push({ count: value[0].count, date: value[0].date, locationName: value[0].location_name });
    //     return file;
    // }, []);

    useEffect(() => {
        props.chartTypes !== '' && setFilteredData(false)
      },[props.chartTypes])

    const NoDataComponent = () =>{
      return (
        <div style={{width: '100%',height: '100%'}}>
        <div style={{textAlign: 'center',height: '100%',position: 'absolute',left: '24rem',top: '16rem',fontSize:"22px"}}>
            <span>No data</span>
        </div>
        </div>
      )
    }
    
    const CustomTooltip = ({ active, payload, location_name }) => {
        if (active && payload && payload.length) {
            return (
                <div class='card'>
                    <div className="custom-tooltip">
                        <div>
                        {payload[0].payload.hasOwnProperty('date') ? <p className="desc">{payload[0].payload.hasOwnProperty('date') ? `${payload[0].payload.date}` : ''}</p> : ''}
                            <p className="desc" style={{ color: "#8884d8" }}>{`count : ${payload[0].value}`}</p>
                        </div>
                    </div>
                </div>
            );
        }

        return null;
    };
    const productionCharts = (chartTypes,productionCount) => {
        switch (chartTypes) {
            case 'ProductionBar':
                return (
                    <>
                    {props.isLoader ? 
                    <div style={{ textAlign: 'center', marginTop: '22%', position:'absolute', marginLeft:'40%' }}>
                        <BeatLoader />
                    </div>  : productionCount > 0 ? 
                        <BarChart
                        width={500}
                        maxBarSize={10}
                        height={300}
                        data={props.data?.productionCountAgainstLocation}
                        margin={{
                            top: 5,
                            right: 50,
                            left: 20,
                            bottom: 5,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="date" angle={-45} textAnchor="end"/>
                        {/* <XAxis dataKey="date">
                    <Label value="Dates" offset={2} position="bottom" />
                </XAxis> */}
                        {/* <YAxis label={{ value: 'count', angle: -90, position: 'insideLeft', textAnchor: 'middle' }} /> */}
                        <YAxis dataKey="count" />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey='count' stroke="#8A2BE2" fill="#8884d8" background={{ fill: '#eee' }}>
                        </Bar>
                    </BarChart> : <NoDataComponent />
                    }
                    </>
                )
            case 'ProductionPie':
                return (
                    <>
                    {props.isLoader ? 
                    <div style={{ textAlign: 'center', marginTop: '22%', position:'absolute', marginLeft:'40%' }}>
                        <BeatLoader />
                    </div>  : productionCount > 0 ? 
                        <PieChart width={400} height={300}>
                            <Pie
                                data={props.data?.productionCountAgainstLocation}
                                dataKey="count"
                                cx="50%"
                                cy="50%"
                                outerRadius={140}
                                fill="#8884d8" />
                            <Tooltip content={<CustomTooltip />} />
                        </PieChart> : <NoDataComponent />}
                    </>
                )
            case 'ProductionDoughnut':
                return (
                    <>
                    {props.isLoader ? 
                    <div style={{ textAlign: 'center', marginTop: '22%', position:'absolute', marginLeft:'40%' }}>
                        <BeatLoader />
                    </div>  : productionCount > 0 ? 
                        <PieChart width={400} height={300}>
                            <Pie
                                data={props.data?.productionCountAgainstLocation}
                                dataKey="count"
                                cx="50%"
                                cy="50%"
                                innerRadius={100}
                                outerRadius={140}
                                paddingAngle={1}
                                fill="#8884d8" />
                            <Tooltip content={<CustomTooltip />} />
                        </PieChart> : <NoDataComponent />}
                    </>
                )
            case 'ProductionLine':
                return (
                        <LineChart
                            width={500}
                            height={300}
                            data={props.data?.productionCountAgainstLocation}
                            margin={{
                                top: 5,
                                right: 30,
                                left: 20,
                                bottom: 5,
                            }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="date" />
                            <YAxis dataKey="count" />
                            <Tooltip />
                            <Legend />
                            <Line type="monotone" dataKey="count" stroke="#8884d8" activeDot={{ r: 8 }} background={{ fill: '#eee' }} />
                        </LineChart>
                )
            default:
                return (
                    <>
                    {props.isLoader ? 
                    <div style={{ textAlign: 'center', marginTop: '22%', position:'absolute', marginLeft:'40%' }}>
                        <BeatLoader />
                    </div>  : productionCount > 0 ? 
                        <BarChart
                        width={500}
                        maxBarSize={10}
                        height={300}
                        data={props.data?.productionCountAgainstLocation}
                        margin={{
                            top: 5,
                            right: 50,
                            left: 20,
                            bottom: 5,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="date" angle={-45} textAnchor="end"/>
                        {/* <XAxis dataKey="date">
                    <Label value="Dates" offset={2} position="bottom" />
                </XAxis> */}
                        {/* <YAxis label={{ value: 'count', angle: -90, position: 'insideLeft', textAnchor: 'middle' }} /> */}
                        <YAxis dataKey="count" />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey='count' stroke="#8A2BE2" fill="#8884d8" background={{ fill: '#eee' }}>
                        </Bar>
                    </BarChart> : <NoDataComponent />
                    }
                    </>
                )
        }
    }

    const dispatchCharts = (chartTypes, dispatchCount) => {
        switch (chartTypes) {
            case 'DispatchBar':
                return (
                    <>
                    {props.isLoader ? 
                    <div style={{ textAlign: 'center', marginTop: '21%', position:'absolute', marginLeft:'40%' }}>
                        <BeatLoader />
                    </div>  : dispatchCount > 0 ? 
                        <BarChart
                            width={500}
                            maxBarSize={10}
                            height={300}
                            data={props.data?.dispatchCountAgainstLocation}
                            margin={{
                                top: 5,
                                right: 50,
                                left: 20,
                                bottom: 5,
                            }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="date"  angle={-45}  textAnchor="end" />
                            {/* <XAxis dataKey="date">
                        <Label value="Dates" offset={2} position="bottom" />
                    </XAxis> */}
                            {/* <YAxis label={{ value: 'count', angle: -90, position: 'insideLeft', textAnchor: 'middle' }} /> */}
                            <YAxis dataKey="count" />
                            <Tooltip />
                            <Legend />
                            <Bar dataKey='count' stroke="#8A2BE2" fill="#8884d8" background={{ fill: '#eee' }}>
                            </Bar>
                        </BarChart> : <NoDataComponent />
                        }
                    </>
                )
            case 'DispatchPie':
                return (
                    <>
                    {props.isLoader ? 
                    <div style={{ textAlign: 'center', marginTop: '21%', position:'absolute', marginLeft:'40%' }}>
                        <BeatLoader />
                    </div>  : dispatchCount > 0 ?
                        <PieChart width={400} height={300}>
                            <Pie
                                data={props.data?.dispatchCountAgainstLocation}
                                dataKey="count"
                                cx="50%"
                                cy="50%"
                                outerRadius={140}
                                fill="#8884d8" />
                            <Tooltip content={<CustomTooltip />} />
                        </PieChart> : <NoDataComponent />}
                    </>
                )
            case 'DispatchDoughnut':
                return (
                    <>
                    {props.isLoader ? 
                    <div style={{ textAlign: 'center', marginTop: '21%', position:'absolute', marginLeft:'40%' }}>
                        <BeatLoader />
                    </div>  : dispatchCount > 0 ?
                        <PieChart width={400} height={300}>
                            <Pie
                                data={props.data?.dispatchCountAgainstLocation}
                                dataKey="count"
                                cx="50%"
                                cy="50%"
                                innerRadius={100}
                                outerRadius={140}
                                paddingAngle={1}
                                fill="#8884d8" />
                            <Tooltip content={<CustomTooltip />} />
                        </PieChart> : <NoDataComponent />}
                    </>
                )
            case 'DispatchLine':
                return (
                        <LineChart
                            width={500}
                            height={300}
                            data={props.data?.dispatchCountAgainstLocation}
                            margin={{
                                top: 5,
                                right: 30,
                                left: 20,
                                bottom: 5,
                            }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="date" />
                            <YAxis dataKey="count" />
                            <Tooltip />
                            <Legend />
                            <Line type="monotone" dataKey="count" stroke="#8884d8" activeDot={{ r: 8 }} background={{ fill: '#eee' }} />
                        </LineChart>
                )
            default:
                return (
                    <>
                    {props.isLoader ? 
                    <div style={{ textAlign: 'center', marginTop: '21%', position:'absolute', marginLeft:'40%' }}>
                        <BeatLoader />
                    </div>  : dispatchCount > 0 ?
                        <BarChart
                            width={500}
                            maxBarSize={10}
                            height={300}
                            data={props.data?.dispatchCountAgainstLocation}
                            margin={{
                                top: 5,
                                right: 50,
                                left: 20,
                                bottom: 5,
                            }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="date"  angle={-45}  textAnchor="end" />
                            {/* <XAxis dataKey="date">
                        <Label value="Dates" offset={2} position="bottom" />
                    </XAxis> */}
                            {/* <YAxis label={{ value: 'count', angle: -90, position: 'insideLeft', textAnchor: 'middle' }} /> */}
                            <YAxis dataKey="count" />
                            <Tooltip />
                            <Legend />
                            <Bar dataKey='count' stroke="#8A2BE2" fill="#8884d8" background={{ fill: '#eee' }}>
                            </Bar>
                        </BarChart> : <NoDataComponent />
                        }
                    </>
                )
        }
    }

    const inwardCharts = (chartTypes, inwardCount) => {
        switch (chartTypes) {
            case 'InwardBar':
                return (
                    <>
                    {props.isLoader ? 
                    <div style={{ textAlign: 'center', marginTop: '21%', position:'absolute', marginLeft:'40%' }}>
                        <BeatLoader />
                    </div>  : inwardCount > 0 ? 
                        <BarChart
                            width={500}
                            height={300}
                            maxBarSize={10}
                            data={props.data?.inwardCountAgainstLocation}
                            margin={{
                                top: 5,
                                right: 50,
                                left: 20,
                                bottom: 5,
                            }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="date"  angle={-45}  textAnchor="end" />
                            {/* <XAxis dataKey="date">
                        <Label value="Dates" offset={2} position="bottom" />
                    </XAxis> */}
                            {/* <YAxis label={{ value: 'count', angle: -90, position: 'insideLeft', textAnchor: 'middle' }} /> */}
                            <YAxis dataKey="count" />
                            <Tooltip />
                            <Legend />
                            <Bar dataKey='count' stroke="#8A2BE2" fill="#8884d8" background={{ fill: '#eee' }}>
                            </Bar>
                        </BarChart> : <NoDataComponent />}
                        </>
                )
            case 'InwardPie':
                return (
                    <>
                    {props.isLoader ? 
                    <div style={{ textAlign: 'center', marginTop: '21%', position:'absolute', marginLeft:'40%' }}>
                        <BeatLoader />
                    </div>  : inwardCount > 0 ?
                        <PieChart width={400} height={300}>
                            <Pie
                                data={props.data?.inwardCountAgainstLocation}
                                dataKey="count"
                                cx="50%"
                                cy="50%"
                                outerRadius={140}
                                fill="#8884d8" />
                            <Tooltip content={<CustomTooltip />} />
                        </PieChart> : <NoDataComponent />}</>
                )
            case 'InwardDoughnut':
                return (
                    <>
                    {props.isLoader ? 
                    <div style={{ textAlign: 'center', marginTop: '21%', position:'absolute', marginLeft:'40%' }}>
                        <BeatLoader />
                    </div>  : inwardCount > 0 ?
                        <PieChart width={400} height={300}>
                            <Pie
                                data={props.data?.inwardCountAgainstLocation}
                                dataKey="count"
                                cx="50%"
                                cy="50%"
                                innerRadius={100}
                                outerRadius={140}
                                paddingAngle={1}
                                fill="#8884d8" />
                            <Tooltip content={<CustomTooltip />} />
                        </PieChart> : <NoDataComponent />}
                    </>
                )
            case 'InwardLine':
                return (
                        <LineChart
                            width={500}
                            height={300}
                            data={props.data?.inwardCountAgainstLocation}
                            margin={{
                                top: 5,
                                right: 30,
                                left: 20,
                                bottom: 5,
                            }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="date" />
                            <YAxis dataKey="count" />
                            <Tooltip />
                            <Legend />
                            <Line type="monotone" dataKey="count" stroke="#8884d8" activeDot={{ r: 8 }} background={{ fill: '#eee' }} />
                        </LineChart>
                )
            default:
                return (
                    <>
                    {props.isLoader ? 
                    <div style={{ textAlign: 'center', marginTop: '21%', position:'absolute', marginLeft:'40%' }}>
                        <BeatLoader />
                    </div> : inwardCount > 0 ?
                        <BarChart
                            width={500}
                            height={300}
                            maxBarSize={10}
                            data={props.data?.inwardCountAgainstLocation}
                            margin={{
                                top: 5,
                                right: 50,
                                left: 20,
                                bottom: 5,
                            }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="date"  angle={-45}  textAnchor="end"/>
                            {/* <XAxis dataKey="date">
                        <Label value="Dates" offset={2} position="bottom" />
                    </XAxis> */}
                            {/* <YAxis label={{ value: 'count', angle: -90, position: 'insideLeft', textAnchor: 'middle' }} /> */}
                            <YAxis dataKey="count" />
                            <Tooltip />
                            <Legend />
                            <Bar dataKey='count' stroke="#8A2BE2" fill="#8884d8" background={{ fill: '#eee' }}>
                            </Bar>
                        </BarChart> : <NoDataComponent />
        }
                    </>
                )
        }
    }

    const inventoryCharts = (chartTypes, inventoryCount) => {
        switch (chartTypes) {
            case 'InventoryBar':
                return (
                    <>
                    {props.isLoader ? 
                    <div style={{ textAlign: 'center', marginTop: '21%', position:'absolute', marginLeft:'40%' }}>
                        <BeatLoader />
                    </div>  : inventoryCount > 0 ?
                        <BarChart
                            width={500}
                            height={300}
                            maxBarSize={10}
                            data={props.data?.inventoryCountAgainstLocation}
                            margin={{
                                top: 5,
                                right: 50,
                                left: 20,
                                bottom: 5,
                            }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="date"  angle={-45}  textAnchor="end"/>
                            {/* <XAxis dataKey="date">
                        <Label value="Dates" offset={2} position="bottom" />
                    </XAxis> */}
                            {/* <YAxis label={{ value: 'count', angle: -90, position: 'insideLeft', textAnchor: 'middle' }} /> */}
                            <YAxis dataKey="count" />
                            <Tooltip />
                            <Legend />
                            <Bar dataKey='count' stroke="#8A2BE2" fill="#8884d8" background={{ fill: '#eee' }}>
                            </Bar>
                        </BarChart> : <NoDataComponent />}
                    </>
                )
            case 'InventoryPie':
                return (
                    <>
                    {props.isLoader ? 
                    <div style={{ textAlign: 'center', marginTop: '21%', position:'absolute', marginLeft:'40%' }}>
                        <BeatLoader />
                    </div>  : inventoryCount > 0 ?
                        <PieChart width={400} height={300}>
                            <Pie
                                data={props.data?.inventoryCountAgainstLocation}
                                dataKey="count"
                                cx="50%"
                                cy="50%"
                                outerRadius={140}
                                fill="#8884d8" />
                            <Tooltip content={<CustomTooltip />} />
                        </PieChart> : <NoDataComponent />}
                    </>
                )
            case 'InventoryDoughnut':
                return (
                    <>
                    {props.isLoader ? 
                        <div style={{ textAlign: 'center', marginTop: '21%', position:'absolute', marginLeft:'40%' }}>
                            <BeatLoader />
                        </div>  : inventoryCount > 0 ?
                        <PieChart width={400} height={300}>
                            <Pie
                                data={props.data?.inventoryCountAgainstLocation}
                                dataKey="count"
                                cx="50%"
                                cy="50%"
                                innerRadius={100}
                                outerRadius={140}
                                paddingAngle={1}
                                fill="#8884d8" />
                            <Tooltip content={<CustomTooltip />} />
                        </PieChart> : <NoDataComponent />}
                    </>
                )
            case 'InventoryLine':
                return (
                        <LineChart
                            width={500}
                            height={300}
                            data={props.data?.inventoryCountAgainstLocation}
                            margin={{
                                top: 5,
                                right: 30,
                                left: 20,
                                bottom: 5,
                            }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="date" />
                            <YAxis dataKey="count" />
                            <Tooltip />
                            <Legend />
                            <Line type="monotone" dataKey="count" stroke="#8884d8" activeDot={{ r: 8 }} background={{ fill: '#eee' }} />
                        </LineChart>
                )
            default:
                return (
                    <>
                    {props.isLoader ? 
                    <div style={{ textAlign: 'center', marginTop: '21%', position:'absolute', marginLeft:'40%' }}>
                        <BeatLoader />
                    </div> : inventoryCount > 0 ?
                        <BarChart
                            width={500}
                            height={300}
                            maxBarSize={10}
                            data={props.data?.inventoryCountAgainstLocation}
                            margin={{
                                top: 5,
                                right: 50,
                                left: 20,
                                bottom: 5,
                            }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="date"  angle={-45}  textAnchor="end"/>
                            {/* <XAxis dataKey="date">
                        <Label value="Dates" offset={2} position="bottom" />
                    </XAxis> */}
                            {/* <YAxis label={{ value: 'count', angle: -90, position: 'insideLeft', textAnchor: 'middle' }} /> */}
                            <YAxis dataKey="count" />
                            <Tooltip content={CustomTooltip} />
                            <Legend />
                            <Bar dataKey='count' stroke="#8A2BE2" fill="#8884d8" background={{ fill: '#eee' }}>
                            </Bar>
                        </BarChart> : <NoDataComponent/>
        }
                    </>
                )
        }
    }

    

    if(props.title === "Production" && props.getProductionCharts){
        return productionCharts(props.getProductionCharts, props.data.production_count)
    }else if(props.title === "Dispatch" && props.getDispatchCharts){
        return dispatchCharts(props.getDispatchCharts,props.data.dispatch_count)
    }
    else if(props.title === "Inward" && props.getInwardCharts){
        return inwardCharts(props.getInwardCharts, props.data.inward_count)
    } else if(props.title === "Inventory" && props.getInventoryCharts){
        return inventoryCharts(props.getInventoryCharts, props.data.inventory_count)
    }
    else{
        switch (props.title) {
            case 'Production':
                return (
                    productionCharts(props.chartTypes, props.data.production_count)
                )
            case 'Dispatch':
                return (
                    dispatchCharts(props.chartTypes, props.data.dispatch_count)
                )
            case 'Inward':
                return (
                    inwardCharts(props.chartTypes, props.data.inward_count)
                )
            case 'Inventory':
                return (
                    inventoryCharts(props.chartTypes, props.data.inventory_count)
                )
            default:
                return null;
        }
    }

    // console.log("charts:",props.selecedTitle)
    //     switch (props.title === props.selecedTitle) {
    //         case 'true': {
    //                 console.log("@3props.title4",props.title)
    //             if (props.title === 'Production') {
    //                 return (
    //                     productionCharts(props.chartTypes)
    //                 )
    //             } else if (props.title === 'Dispatch') {
    //                 return (
    //                     dispatchCharts(props.chartTypes)
    //                 )
    //             } else if (props.title === 'Inward') {
    //                 return (
    //                     inwardCharts(props.chartTypes)
    //                 )
    //             }
    //     }
    //     default :
    //     return null
    // }
    //             if (filteredData) {
    //                 if (props.title === 'Production') {
    //                     return (
    //                         productionCharts(props.chartTypes)
    //                     )
    //                 } else if (props.title === 'Dispatch') {
    //                     return (
    //                         dispatchCharts(props.chartTypes)
    //                     )
    //                 } else if (props.title === 'Inward') {
    //                     return (
    //                         inwardCharts(props.chartTypes)
    //                     )
    //                 }
    //             }
    //             // switch (props.title) {
    //             //     case 'Production':
    //             //         return (
    //             //             productionCharts(props.chartTypes)
    //             //         )
    //             //     case 'Dispatch':
    //             //         return (
    //             //             dispatchCharts(props.chartTypes)
    //             //         )
    //             //     case 'Inward':
    //             //         return (
    //             //             inwardCharts(props.chartTypes)
    //             //         )
    //             //     default:
    //             //         return null;
    //             // }
}


export default Charts;